module.exports = __webpack_public_path__ + "img/home-prize-6.b8263e33.png";